import React from "react";
import EditableTable from "./_EditableTable";

export default function IPLibrary() {
  return (
    <>
      <div className="mb-6">
        <div className="font-mono text-[10px] uppercase tracking-[0.18em] text-zinc-500 section-eyebrow">Reusable IP Layer</div>
        <h2 className="font-display text-2xl md:text-3xl font-extrabold tracking-tight text-zinc-900 mt-1">IP Library</h2>
        <p className="text-sm text-zinc-500 mt-1 max-w-3xl">Template &amp; accelerator library versioned by project type · searchable lessons-learned repository.</p>
      </div>

      <div className="mb-6">
        <div className="font-mono text-[10px] uppercase tracking-[0.14em] text-zinc-500 mb-2">Templates &amp; accelerators</div>
        <EditableTable
          sectionKey="ipLibrary"
          listKey="templates"
          testidPrefix="ip-t"
          labelSingular="template"
          columns={[
            { key: "name", label: "Template name" },
            { key: "type", label: "Type", type: "select", options: ["Charter", "RAID template", "Cutover run-book", "Test script pack", "Communication plan", "RACI", "Data map", "Interface spec", "WRICEF spec"], width: "180px" },
            { key: "projectType", label: "Project type", type: "select", options: ["All", "Greenfield", "Brownfield", "Bluefield", "Rollout", "Optimization"], width: "140px" },
            { key: "version", label: "Version", width: "90px" },
            { key: "location", label: "Location / link" },
            { key: "owner", label: "Owner", width: "120px" },
          ]}
          emptyRow={() => ({ name: "", type: "Charter", projectType: "All", version: "1.0", location: "", owner: "" })}
        />
      </div>

      <div className="mb-6">
        <div className="font-mono text-[10px] uppercase tracking-[0.14em] text-zinc-500 mb-2">Lessons learned</div>
        <EditableTable
          sectionKey="ipLibrary"
          listKey="lessons"
          testidPrefix="ip-l"
          labelSingular="lesson"
          columns={[
            { key: "engagement", label: "Engagement / client", width: "180px" },
            { key: "phase", label: "Phase", type: "select", options: ["Discover", "Prepare", "Explore", "Realize", "Deploy", "Run", "Post-go-live"], width: "130px" },
            { key: "industry", label: "Industry", type: "select", options: ["Life Sciences", "Medical Devices", "Aerospace", "Manufacturing", "Retail", "Utilities", "Public Sector", "Financial Services", "Other"], width: "140px" },
            { key: "module", label: "SAP module", width: "120px" },
            { key: "what", label: "What happened" },
            { key: "action", label: "What we would do differently" },
            { key: "tags", label: "Tags", width: "140px" },
          ]}
          emptyRow={() => ({ engagement: "", phase: "Realize", industry: "Other", module: "", what: "", action: "", tags: "" })}
        />
      </div>
    </>
  );
}
